import { render } from "./TabelaAccordion.vue?vue&type=template&id=ce3fefd2&scoped=true&ts=true"
import script from "./TabelaAccordion.vue?vue&type=script&lang=ts"
export * from "./TabelaAccordion.vue?vue&type=script&lang=ts"

import "./TabelaAccordion.vue?vue&type=style&index=0&id=ce3fefd2&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3fefd2"],['__file',"src/components/TabelaAccordion/TabelaAccordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ce3fefd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ce3fefd2', __exports__)) {
    api.reload('ce3fefd2', __exports__)
  }
  
  module.hot.accept("./TabelaAccordion.vue?vue&type=template&id=ce3fefd2&scoped=true&ts=true", () => {
    api.rerender('ce3fefd2', render)
  })

}


export default __exports__